import { Pipe, PipeTransform } from '@angular/core';
import { yearsOld } from 'src/app/utils/date';

@Pipe({
  name: 'age',
})
export class AgePipe implements PipeTransform {
  transform(value: Date | string, ...args: unknown[]): string {
    if (!value) return '';
    const date = typeof value === 'string' ? new Date(value) : value;
    return yearsOld(date) + ' Anos';
  }
}
